if (!customElements.get('video-carousel-item')) {
  class VideoCarouselItem extends HTMLElement {
    constructor() {
      super();
      this.videos = Array.from(this.querySelectorAll('[data-video-element]'));
      this.posterButton = this.querySelector('[data-poster-button]');
      this.activeVideo = null;
    }

    connectedCallback() {
      if (!this.videos.length || !this.posterButton) return;
      this.posterButton.addEventListener('click', this.handlePlay.bind(this));
      this.videos.forEach((video) => {
        video.addEventListener('play', this.markPlaying.bind(this));
        video.addEventListener('pause', this.markPaused.bind(this));
        video.addEventListener('ended', this.reset.bind(this));
      });
    }

    pickVariant() {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const want = isMobile ? 'mobile' : 'desktop';
      const match = this.videos.find((v) => v.dataset.videoVariant === want);
      return match || this.videos[0];
    }

    handlePlay() {
      this.activeVideo = this.pickVariant();
      if (!this.activeVideo) return;
      this.activeVideo.hidden = false;
      this.classList.add('is-playing');
      const playPromise = this.activeVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    markPlaying() {
      this.classList.add('is-playing');
      this.dispatchEvent(new CustomEvent('video-carousel:playing', { bubbles: true }));
    }

    markPaused() {
      this.dispatchEvent(new CustomEvent('video-carousel:paused', { bubbles: true }));
    }

    reset() {
      this.videos.forEach((video) => {
        if (!video.paused) video.pause();
        video.currentTime = 0;
        video.hidden = true;
      });
      this.classList.remove('is-playing');
      this.activeVideo = null;
      this.dispatchEvent(new CustomEvent('video-carousel:paused', { bubbles: true }));
    }

    pause() {
      this.reset();
    }
  }
  customElements.define('video-carousel-item', VideoCarouselItem);
}

if (!customElements.get('m-video-carousel')) {
  class MVideoCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('video-carousel-item'));
      this.section = this.closest('.m-video-carousel');
      this.initSlider();
      this.bindEvents();
    }

    initSlider() {
      const SwiperLib = (window.MinimogLibs && window.MinimogLibs.Swiper) || window.Swiper;
      if (!SwiperLib) {
        // Fallback: keep slides stacked if Swiper is not available.
        return;
      }

      this.slider = new SwiperLib(`.m-slider-${this.dataset.id}`, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        loop: false,
        watchOverflow: true,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
          bulletClass: 'm-dot',
          bulletActiveClass: 'm-dot--active',
        },
        on: {
          slideChange: () => this.pauseAll(),
        },
      });

      document.addEventListener('shopify:block:select', (e) => this.onBlockSelect(e));
      document.addEventListener('shopify:block:deselect', () => this.pauseAll());
    }

    bindEvents() {
      this.addEventListener('video-carousel:playing', () => this.setPlayingState(true));
      this.addEventListener('video-carousel:paused', () => {
        const stillPlaying = this.items.some((item) => item.classList.contains('is-playing'));
        if (!stillPlaying) this.setPlayingState(false);
      });
    }

    setPlayingState(isPlaying) {
      if (this.section) this.section.classList.toggle('is-playing', isPlaying);
    }

    pauseAll() {
      this.items.forEach((item) => {
        if (typeof item.pause === 'function') item.pause();
      });
      this.setPlayingState(false);
    }

    onBlockSelect(e) {
      if (!this.contains(e.target)) return;
      this.pauseAll();
      const slide = e.target.closest('[data-slide]');
      if (slide && this.slider) {
        const index = Number(slide.dataset.slide);
        this.slider.slideTo(index);
      }
    }
  }
  customElements.define('m-video-carousel', MVideoCarousel);
}
